import api from '@/helpers/api'

const API_PREFIX = `/api/tax-service/`
const API_PREFIX_APP = `${API_PREFIX}apps/`

export default {
  namespaced: true,
  state: {
    status: '',
    taxServices: [],
    taxServiceApps: [],
    currUser: {},
    errMessage: '',
    meta: {
      limit: 10,
      page: 1,
      total: 1
    }
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    success(state) {
      state.status = 'success'
    },
    error(state, { message }) {
      state.status = 'error'
      state.errMessage = message
    },
    read(state, { taxServices }) {
      state.taxServices = [...taxServices]
    },
    read_single_success(state, { taxService }) {
      state.taxServices = [taxService]
    },
    readApps(state, { taxServiceApps }) {
      state.taxServiceApps = [...taxServiceApps]
    },
    read_single_apps_success(state, { taxServiceApp }) {
      state.taxServiceApps = [taxServiceApp]
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta }
    }
  },
  actions: {
    read({ commit, state }) {
      commit('request')
      const { meta } = state

      return new Promise((resolve, reject) => {
        api.request('get', API_PREFIX, { meta })
          .then((result) => {
            commit('read', { taxServices: result.data.data })
            commit('switch_page', { meta: { ...result.data.meta } })
            commit('success')
            resolve(result)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err)
          })
      })
    },

    read_single({ commit }, id) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('get', `${API_PREFIX}${id}`)
          .then((result) => {
            commit('read_single_success', { taxService: result.data.data })
            commit('success')
            resolve(result.data.data)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err.response.data)
          })
      })
    },

    create({ commit }, { data }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('post', API_PREFIX, {}, data)
          .then((result) => {
            commit('success')
            resolve(result)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err)
          })
      })
    },

    update({ commit }, { data }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('put', `${API_PREFIX}${data.id}`, {}, data)
          .then((result) => {
            commit('success')
            resolve(result)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err)
          })
      })
    },

    delete({ commit }, id) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('delete', `${API_PREFIX}${id}`)
          .then((result) => {
            commit('success')
            resolve(result.data)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err.response.data)
          })
      })
    },

    readApps({ commit, state }) {
      commit('request')
      const { meta } = state

      return new Promise((resolve, reject) => {
        api.request('get', API_PREFIX_APP, { meta })
          .then((result) => {
            commit('readApps', { taxServiceApps: result.data.data })
            commit('switch_page', { meta: { ...result.data.meta } })
            commit('success')
            resolve(result)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err)
          })
      })
    },

    read_single_apps({ commit }, id) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('get', `${API_PREFIX_APP}${id}`)
          .then((result) => {
            commit('read_single_apps_success', { taxServiceApp: result.data.data })
            resolve(result.data.data)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err.response.data)
          })
      })
    },

    createApps({ commit }, { data }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('post', API_PREFIX_APP, {}, data)
          .then((result) => {
            commit('success')
            resolve(result)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err)
          })
      })
    },

    updateApps({ commit }, { data }) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('put', `${API_PREFIX_APP}${data.id}`, {}, data)
          .then((result) => {
            commit('success')
            resolve(result)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err)
          })
      })
    },

    deleteApps({ commit }, id) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('delete', `${API_PREFIX_APP}${id}`)
          .then((result) => {
            commit('success')
            resolve(result.data)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err.response.data)
          })
      })
    },
    read_single_transaction({ commit }, id) {
      commit('request')

      return new Promise((resolve, reject) => {
        api.request('get', `${API_PREFIX}service/${id}`)
          .then((result) => {
            commit('read_single_success', { taxService: result.data.data })
            commit('success')
            resolve(result.data.data)
          }).catch((err) => {
            commit('error', { message: err })
            reject(err.response.data)
          })
      })
    },
  },
  getters: {
    taxServices: (state) => state.taxServices,
    taxServiceApps: (state) => state.taxServiceApps
  }
}
